module.exports = __webpack_public_path__ + "static/media/home_page_banner@768.2de34ba1.png";